<template>
  <v-card flat :style="`height: ${ windowSize.y }px; position: 'relative'`" class="pa-1 product-view" v-resize="onResizeHandler">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pa-0">
      <v-form ref="receiveForm" v-on:submit.prevent>
        <v-row>
          <v-col cols="12" class="pb-0 pt-0 font-weight-bold">{{ orderModel.number }} {{ orderModel.salesreference && orderModel.salesreference.trim() !== '' ? ' - ' + orderModel.salesreference : '' }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pr-1 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scanProduct" flat autocomplete="off"
              ref="scanProduct" @change="getRespectiveProductOrder" :loading="productLoading"
            :placeholder="$t('message.order.scanProduct')"></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-1 pb-1 font-weight-bold" v-if="productFound">
            {{ productInfo.productname || '' }}
          </v-col>
          <template v-if="productFound && productInfo.isbatch">
            <v-col cols="8" class="pt-0 pb-0">
              <v-text-field outlined dense hide-details v-model="selectBatch" flat autocomplete="off"
              :rules="$_requiredValidation" :placeholder="$t('message.product.batch')" ref="batchRef"
              :loading="loadingBatch"></v-text-field>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="productFound">
          <v-col cols="10" class="pa-1">
            <v-row>
              <v-col cols="3" class="text-center pa-0" @click="decreaseQty">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-text-field outlined dense hide-details type="number" class="text-right" v-model="pickQty"
                  autocomplete="off" ref="qtyRef" :rules="$_qtyValidation" :placeholder="$t('message.product.qty')"></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center pa-0" @click="increaseQty">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="productFound">
          <v-col cols="8" class="pt-0 pb-0">
            <v-text-field outlined dense hide-details v-model="selectedLocation" flat autocomplete="off"
                :rules="$_requiredValidation" @change="checkIfLocationValid" :loading="loadingLocation"
                ref="scanLocation" :placeholder="$t('message.product.scanLoc')"></v-text-field>
          </v-col>
          <v-col cols="4" class="pa-1 mt-1">
            <v-btn color="primary" dark small @click="completeOrderHandler">
              {{ $t('message.order.receive') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <!-- LIST OF PRODUCTS -->
    <v-card-text class="pt-0 pb-0 pl-1 mt-2 pickProducts">
      <v-row class="highlight">
        <v-col cols="5" class="pa-0 pl-3 font-weight-bold">{{ $t('message.dashboard.product') }}:</v-col>
        <v-col cols="1" class="pa-0 pl-3 font-weight-bold">{{  $t('message.order.location') }}:</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.received') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.rest') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts" :key="index" class="productRow" @click="updateProductForPicking(product)">
        <v-col cols="5" class="pa-0 pl-3 text-truncate" :title="product.productnumber" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
          {{ product.productnumber }}
          <br />
          <span class="productInfo">{{ product.productname }}</span>
        </v-col>
        <v-col cols="1" class="pa-0 pl-3 text-truncate">
          <v-row v-for="(location, index) in product.receivedorders" :key="`${index}_location`">
            <v-col cols="12" class="pa-0 text-truncate" :title="location.locationname">{{ location.locationname }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0 text-right text-truncate">{{ product.qty | absoluteNumber }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right text-truncate">{{ product.receivedqty_ref | absoluteNumber }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right text-truncate">
          {{ product.rest_qty | absoluteNumber }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-btn color="primary" dark absolute bottom left @click="$router.push(`/supplier_orders/${orderId}`)">
      <v-icon left>mdi-arrow-left-bold</v-icon>{{ $t('message.login.back') }}
    </v-btn>
    <v-dialog v-model="completeDialog" persistent class="mt-0">
      <v-card>
        <v-card-title class="pa-2">
          {{ $t('message.ccsheet.info') }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2">
          <h4>{{ $t('message.order.receiveLessWarning', { qty: ($format.absoluteNumber(pickQty)), product: `${productInfo.productnumber || ''}` }) }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" small :loading="saveLoading" @click="receiveQtyOnOrder">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="success" small @click="completeDialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Picking qty is greater than ordered -->
    <v-dialog v-model="moreQtyObj.dialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h4>{{ $t('message.order.orderedQtyHigh') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="moreQtyObj.onSuccess">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" @click="moreQtyObj.onCancel">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      scanProduct: '',
      windowSize: {
        x: 0,
        y: 0
      },
      productFound: false,
      productInfo: {},
      pickQty: '',
      listOfLocations: [],
      selectedLocation: '',
      selectedLocationId: 0,
      selectBatch: '',
      saveLoading: false,
      loadingBatch: false,
      productLoading: false,
      loadingLocation: false,
      completeDialog: false,
      moreQtyObj: {
        dialog: false
      },
      savedLocationForUpcomingRecords: ''
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.order_id
    this.getOrderProducts()
    this.getOrderInfo()
    this.onResizeHandler()
    this.focusField('scanProduct')
  },
  watch: {
    pickQty (val) {
      let pickedQty = parseFloat(this.$format.replaceCommaWithDot(val || 0))
      let products = this.$format.cloneVariable(this.listOfProducts)
      let getFoundProd = products.find(x => x.productid === this.productInfo.productid)
      if (getFoundProd) {
        var totalQty = 0
        var receivedCount = 0
        if (getFoundProd.receivedorders) {
          for (let i = 0; i < getFoundProd.receivedorders.length; i++) {
            if (i !== getFoundProd.receivedorders.length) {
              let receivedQty = this.$format.replaceCommaWithDot(getFoundProd.receivedorders[i].receivedqty)
              receivedCount += parseFloat(receivedQty)
            }
          }
        }
        totalQty += parseFloat(receivedCount)
        if (pickedQty) {
          let parentReceivedQty = pickedQty
          totalQty += parentReceivedQty
        }
        let orderedQty = this.$format.replaceCommaWithDot(getFoundProd.qty)
        if (parseFloat(orderedQty) < totalQty) {
          // totalQty = parseFloat(orderedQty) - parseFloat(receivedCount)
          // this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
          // setTimeout(() => {
          //   this.pickQty = totalQty
          // })
          this.moreQtyObj = {
            dialog: true,
            onSuccess: () => {
              this.moreQtyObj.dialog = false
            },
            onCancel: () => {
              totalQty = parseFloat(orderedQty) - parseFloat(receivedCount)
              setTimeout(() => {
                this.pickQty = totalQty
              })
              this.moreQtyObj.dialog = false
            }
          }
        }
      }
    }
  },
  methods: {
    getOrderInfo () {
      let model = {
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'warehouseorders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
            this.getAllLocationsByWarehouse()
          }
        })
    },
    getAllLocationsByWarehouse () {
      let model = {
        filter: `isactive eq '1' AND warehouseid eq '${this.orderModel.warehouseid}'`
      }
      this.$api.execute('post', 'warehouselocations/query', model)
        .then((response) => {
          if (response.data) {
            this.listOfLocations = response.data
          }
        })
    },
    getOrderProducts () {
      this.loading = true
      this.$api.execute('get', `/warehouseorderitems/get_by_order_pwa/${this.orderId}`)
        .then((response) => {
          this.listOfProducts = []
          if (response.data) {
            let products = response.data
            if (products) {
              if (products) {
                for (let i = 0; i < products.length; i++) {
                  let receivedCount = 0
                  for (let j = 0; j < products[i].receivedorders.length; j++) {
                    let receivedQty = this.$format.replaceCommaWithDot(products[i].receivedorders[j].receivedqty)
                    receivedCount += receivedQty ? parseFloat(receivedQty) : 0
                  }
                  products[i].receivedqty = ''
                  products[i].receivedqty_ref = receivedCount
                  products[i].rest_qty = products[i].qty - receivedCount
                }
              }
              this.listOfProducts = products
            }
            this.restorePreset()
            this.productInfo = {}
            this.scanProduct = ''
            this.productFound = false
            this.focusField('scanProduct')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateProductForPicking (product) {
      this.scanProduct = product.productnumber
      this.getRespectiveProductOrder(product)
    },
    getRespectiveProductOrder (productItem) {
      const productItemId = productItem.id
      this.selectedLocation = this.savedLocationForUpcomingRecords || ''
      if (this.scanProduct) {
        this.productLoading = true
        let list = this.$format.cloneVariable(this.listOfProducts)
        if (list) {
          const scanedLower = this.scanProduct.toLowerCase()
          let getProduct = {}
          if (productItemId) {
            getProduct = list.find(x => x.id === productItemId)
          } else {
            getProduct = list.find(x => (x.barcode || '').toLowerCase() === scanedLower || (x.productnumber || '').toLowerCase() === scanedLower || (x.productnumberbarcode || '').toLowerCase() === scanedLower)
          }
          if (getProduct) {
            this.productFound = true
            this.productInfo = getProduct
            if (getProduct.isbatch) {
              this.focusField('batchRef')
            } else {
              this.focusField('qtyRef')
            }
          } else {
            this.productInfo = {}
            this.productFound = false
            this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noProductFound') })
            this.focusField('scanProduct')
            this.scanProduct = ''
          }
          this.restorePreset()
        }
        this.productLoading = false
      }
    },
    completeOrderHandler () {
      let pickedQty = this.$format.replaceCommaWithDot(this.pickQty || 0)
      let orderedQty = this.$format.replaceCommaWithDot(this.productInfo.rest_qty || 0)
      setTimeout(() => {
        if (this.$refs.receiveForm.validate() && pickedQty > 0) {
          if (pickedQty < orderedQty) { // When picked is less than orderedqty show warning!
            this.completeDialog = true
          } else {
            this.receiveQtyOnOrder()
          }
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        }
      })
    },
    receiveQtyOnOrder () {
      let pickedQty = this.$format.replaceCommaWithDot(this.pickQty || 0)
      if (this.$refs.receiveForm.validate() && pickedQty > 0) {
        this.saveLoading = true
        let locationid = this.selectedLocationId || 0
        this.savedLocationForUpcomingRecords = this.selectedLocation
        let products = this.$format.cloneVariable(this.listOfProducts)
        let model = products.find(x => x.productid === this.productInfo.productid)
        let listOfItems = products.filter(x => x.id !== model.id)
        if (model) {
          if (!model.receivedorders) model.receivedorders = []
          model.locationid = locationid
          model.receivedqty = pickedQty
          model.receivedorders.push({
            batchnumber: this.selectBatch || '',
            receivedqty: pickedQty,
            locationid
          })
        }
        listOfItems.push(model)
        if (locationid) {
          let modelObj = { 'items': listOfItems }
          this.$api.execute('post', `/warehouseorderitems/bulk_save_pwa/${this.orderId}/false`, modelObj)
            .then((response) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
              this.completeDialog = false
              if (response.data && response.data.status === 'received') this.$router.push('/supplier_orders')
              else this.getOrderProducts()
            })
            .finally(() => {
              this.saveLoading = false
            })
        } else {
          this.saveLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    onResizeHandler () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 40 }
    },
    decreaseQty () {
      if (this.pickQty > 0) this.pickQty--
    },
    increaseQty () {
      if (this.pickQty < 0) this.pickQty = ''
      this.pickQty++
    },
    checkIfLocationValid () {
      this.loadingLocation = true
      let locations = this.listOfLocations
      let getOnStockValue = locations.find(x => x.name === this.selectedLocation)
      if (getOnStockValue) {
        this.selectedLocationId = getOnStockValue.id
        // this.checkTheBatchnumber()
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
        setTimeout(() => {
          this.selectedLocation = ''
          this.selectedLocationId = 0
          this.focusField('scanLocation')
        })
      }
      this.loadingLocation = false
    },
    focusField (value) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (this.$refs[value]) {
            this.$refs[value].focus()
          }
        }, 300)
      })
    },
    restorePreset () {
      this.selectBatch = ''
      this.pickQty = ''
      this.selectedLocation = this.savedLocationForUpcomingRecords || ''
      this.selectedLocationId = 0
    }
  }
}
</script>
